$(function () {
    $('.dropdown-toggle').dropdown();
    $('body').tooltip({selector: '[data-toggle="tooltip"]'});
    $('body').popover({selector: '[data-toggle="popover"]'});

    $('.btn-number').click(function (e) {
        e.preventDefault();

        fieldName = $(this).attr('data-field');
        type = $(this).attr('data-type');
        var input = $("input[name='" + fieldName + "']");
        var currentVal = parseInt(input.val());
        if (!isNaN(currentVal)) {
            if (type == 'minus') {
                if (currentVal > input.attr('min')) {
                    input.val(currentVal - 1).change();
                }
                if (parseInt(input.val()) == input.attr('min')) {
                    $(this).attr('disabled', true);
                }
            } else if (type == 'plus') {
                if (currentVal < input.attr('max')) {
                    input.val(currentVal + 1).change();
                }
                if (parseInt(input.val()) == input.attr('max')) {
                    $(this).attr('disabled', true);
                }
            }
        } else {
            input.val(0);
        }
    });

    $('.input-number').focusin(function () {
        $(this).data('oldValue', $(this).val());
    });

    $('.input-number').change(function () {

        minValue = parseInt($(this).attr('min'));
        maxValue = parseInt($(this).attr('max'));
        valueCurrent = parseInt($(this).val());

        name = $(this).attr('name');
        if (valueCurrent >= minValue) {
            $(".btn-number[data-type='minus'][data-field='" + name + "']").removeAttr('disabled')
        } else {
            alert('Sorry, the minimum value was reached');
            $(this).val($(this).data('oldValue'));
        }
        if (valueCurrent <= maxValue) {
            $(".btn-number[data-type='plus'][data-field='" + name + "']").removeAttr('disabled')
        } else {
            alert('Sorry, the maximum value was reached');
            $(this).val($(this).data('oldValue'));
        }
    });

    $(".input-number").keydown(function (e) {
        // Allow: backspace, delete, tab, escape, enter and .
        if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
            // Allow: Ctrl+A
            (e.keyCode == 65 && e.ctrlKey === true) ||
            // Allow: home, end, left, right
            (e.keyCode >= 35 && e.keyCode <= 39)) {
            // let it happen, don't do anything
            return;
        }
        // Ensure that it is a number and stop the keypress
        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
            e.preventDefault();
        }
    });

    if (Cookies.get("cookie-consent") === undefined) {
        $(".cookie-consent").removeClass("hidden");
    }

    $(".cookie-consent .close").click(function (e) {
        e.preventDefault();

        $(".cookie-consent").addClass("hidden");

        Cookies.set("cookie-consent", true, {
            expires: 30,
            path: '/',
            secure: window.location.protocol.includes("https")
        });
    });
    if ($('.next-text-btn').length) {
        $('.next-text-btn').on('click', function () {
            let $this = $(this);
            if ($this.hasClass('open')) {
                $this.removeClass('open')
                    .text('Devamını Göster')
                    .prev('.next-text').stop().slideUp();
            } else {
                $this.addClass('open')
                    .text('Devamını Gizle')
                    .prev('.next-text').stop().slideDown();
            }
        });
    }
});

(function () {
    'use strict';
    window.addEventListener('load', function () {
        // Fetch all the forms we want to apply custom Bootstrap validation styles to
        var forms = document.getElementsByClassName('needs-validation');
        // Loop over them and prevent submission
        Array.prototype.filter.call(forms, function (form) {
            form.addEventListener('submit', function (event) {
                if (!form.checkValidity()) {
                    event.preventDefault();
                    event.stopPropagation();
                }
                form.classList.add('was-validated');
            }, false);
        });
    }, false);
})();

var scrollTop = $(".scroll-top-btn");
$(window).scroll(function () {
    var topPos = $(this).scrollTop();
    if (topPos > 700) {
        $(scrollTop).css({'opacity': '1', 'pointer-events': 'all'});
    } else {
        $(scrollTop).css({"opacity": "0", 'pointer-events': 'none'});
    }
});

$(scrollTop).click(function () {
    $('html, body').animate({
        scrollTop: 0
    }, 800);

    return false;
});

$(window).on("hashchange", function (e) {
    if (window.location.hash !== "modal") {
        $(".modal").modal("hide");
    }
});

$(document).on('show.bs.modal', ".modal", function (e) {
    window.location.hash = "modal";
});

$(document).on('hidden.bs.modal', ".modal", function (e) {
    $('body').removeClass('no-scroll');
    $("html").removeClass("non-sc");
    removeLocationHash();
});

function removeLocationHash() {
    var noHashURL = window.location.href.replace(/#.*$/, '');
    window.history.replaceState('', document.title, noHashURL)
}

window.onload = function () {
    if (window.google && window.google.accounts && window.google.accounts.id) {
        window.google.accounts.id.initialize({
            client_id: "29820961146-huoj6dlc5tb8tm6kf3nvl0s97t1uvvg5.apps.googleusercontent.com",
            callback: callbackResponse
        });

        function callbackResponse(response) {
            fetch(config.googleOneTap + "?token=" + response.credential, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'}
            })
                .then(function (response) {
                    return response.json()
                })
                .then(function (response) {
                    if (response) {
                        if (response.redirectUrl) {
                            window.location.reload();
                        } else if (response.errorMessage) {
                            showError(response.errorMessage);
                        }
                    }
                });
        }

        window.google.accounts.id.prompt(function (e) {
            if (e.isSkippedMoment())
                switch (e.getSkippedReason()) {
                    case "auto_cancel":
                        console.log("One-tap action has been auto cancelled");
                        break;
                    case "user_cancel":
                        console.log("User cancelled one-tap action");
                        break;
                    case "tap_outside":
                        console.log("User cancelled one-tap tapping outside");
                        break;
                    case "issuing_failed":
                        console.log("Onetap error, unsuccesful operation type or unexpected error: issuing_failed");
                        break;
                    default:
                        console.log("Unknown. Unexpected one-tap prompting error")
                }
            else if (e.getNotDisplayedReason())
                switch (e.getNotDisplayedReason()) {
                    case "browser_not_supported":
                    case "invalid_client ":
                    case "missing_client_id":
                    case "opt_out_or_no_session":
                    case "secure_http_required":
                    case "suppressed_by_user":
                    case "unregistered_origin":
                    case "unknown_reason":
                        console.log("One-tap action has skipped due to: " + e.getNotDisplayedReason());
                    default:
                        console.log("Unknown. Unexpected one-tap prompting error")
                }
        });
    }
}

$(document).on('show.bs.modal', "#timeoutModal", function () {
    $("#btn-restart-session").click(function (e) {
        e.preventDefault();
        var reservationId = "";
        if (window.reservation)
            reservationId = window.reservation.reservationId;

        fetch(config.restartSession + "?reservationId=" + reservationId, {
            method: "POST",
            headers: {"Content-Type": "application/json"},
            body: JSON.stringify(window.searchModel),
        })
            .then(function (response) {
                return response.json()
            })
            .then(function (response) {
                if (response.redirectUrl) {
                    window.location = response.redirectUrl;
                } else {
                    alert("Yeniden arama yapılırken bir hata oluştu.");
                }
            });
    })
});

$(document).on("click", "#btn-newsletter", function (e) {
    var newsletterEmail = $("#newsletter-email").val();

    if (newsletterEmail !== "") {
        fetch(config.newsletterSubscription + "?email=" + newsletterEmail, {
            method: "POST",
            headers: {"Content-Type": "application/json"},
        })
            .then(function (response) {
                return response.json()
            })
            .then(function (response) {
                if (response.success == true) {
                    $("#newsletter-error").addClass("d-none");
                    $("#newsletter-success").removeClass("d-none");
                    $("#newsletter-email").val("");
                } else {
                    $("#newsletter-error").text(response.errorMessage).removeClass("d-none");
                    $("#newsletter-success").addClass("d-none");
                }
            })
    }
});

function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

function monthDiff(d1, d2) {
    var months;
    months = (d2.getFullYear() - d1.getFullYear()) * 12;
    months -= d1.getMonth() + 1;
    months += d2.getMonth();
    // edit: increment months if d2 comes later in its month than d1 in its month
    if (d2.getDate() >= d1.getDate())
        months++
    // end edit

    return months <= 0 ? 0 : months;
}

function showSuccess(message) {
    showMessage(message, 'success');
}

function showInfo(message) {
    showMessage(message, 'info');
}

function showWarning(message) {
    showMessage(message, 'warning');
}

function showError(message) {
    showMessage(message, 'error');
}

function showMessage(message, type) {
    $("#notificationModal .message").html(message);
    $("#notificationModal").modal("show");
}

var creditCardTests = {
    'visa': /^4/,
    'mastercard': /^5[1-5]/,
    'amex': /^3(4|7)/,
    'discover': /^6011/,
    'maestro': /^(5018|5020|5038|5893|6304|6759|6761|6762|6763)/
};

function getCreditCardVendor(creditCardNumber) {
    var creditCardVendor = '';
    $.each(creditCardTests, function (vendor, pattern) {
        if (pattern.test(creditCardNumber)) {
            creditCardVendor = vendor;
            return false;
        }
    });

    return creditCardVendor;
}

String.prototype.replaceAll = function (search, replacement) {
    var target = this;
    return target.replace(new RegExp(search, 'g'), replacement);
};

$(document).on('click', 'a[href^="#"]', function (e) {
    e.preventDefault();

    if($(this).attr('href') === "#")
        return;
    
    var element = $($(this).attr('href'))[0];
    var elementPosition = element.getBoundingClientRect().top;

    window.scrollBy({
        top: elementPosition - 15,
        behavior: "smooth"
    });
});
